import { Flex, Text } from '@chakra-ui/react'

import LoadingDots from '../../components/loadingDots'

export const Loading = () => {
  return (
    <Flex background="#0c0c0c" h="100vh" align="center" justify="center" direction="column">
      <img src="/img/logo.png" alt="ABRA" style={{ margin: '0 auto' }} />
      <Text color="white">
        Carregando
        <LoadingDots />
      </Text>
    </Flex>
  )
}
